import { ngFrameworkLoaded } from "@/shared/ng/ng-integration";
import { createApp, watch } from "vue";
import * as UrlUtils from "@/shared/composables/use-url-parms-helper";
import { useWecomaIntegration } from "@/shared/composables/wecoma/use-wecoma-integration";
import ConsentBar from "@/shared/components/organisms/ConsentBar.vue";
import { useNgSession } from "@/shared/ng/ng-session";
import { logException } from "@/shared/utils/logger/use-app-logger";

const code = "da";
let loaded = false;

async function init() {
    if (loaded) return;

    loaded = true;

    initConsentBar();

    ngFrameworkLoaded();

    const query = UrlUtils.getQueryString("redirectWecoma");
    if (query || query === "") {
        await ngFrameworkLoaded();
        const { isLoggedIn } = useNgSession();
        if (isLoggedIn.value) {
            openConsetsCenter("_self");
            return;
        }

        const watcherStop = watch(isLoggedIn, (newVal) => {
            if (newVal) {
                openConsetsCenter("_self");
            }
        });

        ng_hs.loginAborted(() => {
            watcherStop();
        });
    }
}

async function initConsentBar() {
    try {
        const { shouldCookieBarOpen } = useWecomaIntegration();
        if (!(await shouldCookieBarOpen())) return;

        const component = createApp(ConsentBar);

        const root = document.createElement("div");
        document.body.appendChild(root);
        component.mount(root);
    } catch (error) {
        logException("consent-bar", error, { message: "Error while initializing consent bar" });
    }
}

function openConsetsCenter(target: "_self" | "_blank" = "_blank") {
    window.open(getLinkToPrefCenter(), target);
}

function getLinkToPrefCenter(): string {
    const domain = environment.settings["Integrations:Wecoma:Domain"];

    const link = `${domain}?locale=cs-CZ&key=${code}&c=${code}`;

    const { isLoggedIn, session } = useNgSession();

    //TODO 8.4.2022 - Avoid using sessionToken - How to get rid of sessionToken from link?
    return !isLoggedIn.value
        ? link
        : link + `&playerId=${session.value.PlayerID}&sessionToken=${session.value.SessionToken}`;
}

export function useGdpr() {
    return {
        init,
        getLinkToPrefCenter,
        code,
    };
}
